import React from 'react'
import styles from './Button.module.css'
import Spinner from '../Spinner/Spinner'
import classNames from 'classnames/bind'
let cx = classNames.bind(styles)

class Button extends React.Component {
    render() {
        return (
            <div
                className={cx({
                    loginButton: true,
                    disabled: this.props.pending,
                })}
            >
                <div>{this.props.children}</div>
                {this.props.pending ? (
                    <div className={styles.spinWrap}>
                        <Spinner lineFgColor="#e6a500" size={20} />
                    </div>
                ) : null}
            </div>
        )
    }
}

export default Button
